import React from 'react';
import LoginForm from '../components/login'; // Assuming LoginForm.js is in src/components

function LoginPage() {
  return (
      <LoginForm />
  );
}

export default LoginPage;